import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {RESOURCES as reportsResources} from '../fuseInventoryOrdersResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import FuseTheme from '../global/theme';
import {commonStyles} from '../shared/styles';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.accent2Color,
        color: FuseTheme.palette.textColor,
        fontWeight: '400',
        margin: 0,
        padding: '0.25em 0.5em'
    },
    btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 10
    }
};

class DialogInventoryOrderAdjustToAvailable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            loading: false,
            message: null
        };

        this.submitOrderData = this.submitOrderData.bind(this);
    }

    submitOrderData = () => {
        this.setState({
            loading: true,
            message: 'Submitting adjustments...'
        });

        let params = {
            job_id: this.props.jobId,
            location_id: this.props.locationId
        };

        let resource = reportsResources.OrderLocationAdjustToAvailable.GET_ONE(params);

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data) {
                this.processSubmission(result.data);
            }
        }).catch((error) => {
            let message = 'Sorry, there was an error adjusting this Location Order\'s requested cases.';
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                }
            } else if (error.request) {
                // No response
            } else {
                console.log('Inventory Order Detail Error: ', error.message);
            }
            this.setState({
                error: true,
                message: message,
                loading: false
            });
        });
    };

    processSubmission = (response) => {
        let error = false;
        let message = '';
        if (response.message && response.message.includes('success')) {
            message = 'Adjustments made to all applicable products. Refreshing...';
        } else if (response.error) {
            error = true;
            message = 'Sorry, there was an error adjusting this Location Order\'s case quantities.';
        }

        this.setState({
            error: error,
            loading: false,
            message: message
        }, () => {
            setTimeout(() => {
                if (typeof this.props.onSuccess === 'function') {
                    this.props.onSuccess(error);
                }
            }, 600);
        });
    };

    handleCancel = () => {
        if (typeof this.props.onCancel === 'function') {
            this.props.onCancel();
        }
    };

    render() {
        const {
            locationId
        } = this.props;

        const {
            loading,
            message
        } = this.state;

        return (
            <div className="dialog-content-container">
                <div className="reports-table-title" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        Adjust requested cases for {(locationId) ? 'Location ' + locationId : 'this Location'}
                    </h3>
                </div>
                {message &&
                    <p>
                        {message}
                    </p>
                }
                {!loading && !message &&
                    <Fragment>
                        <p>
                            Are you sure you want to adjust all requested cases
                            for {(locationId) ? 'Location ' + locationId : 'this Location'}?
                        </p>
                        <p>
                            This will create overrides to case quantities, using the lesser value of Requested Cases or
                            Estimated Available, to bring the requested quantity closer to the forecasted quantity.
                        </p>
                    </Fragment>
                }

                <div style={styles.btnContainer}>
                    <RaisedButton
                        primary
                        type="button"
                        label="Adjust to Available"
                        onClick={this.submitOrderData}
                        style={commonStyles.buttonInlineRight}
                        disabled={!!(loading)}
                    />
                    <RaisedButton
                        type="button"
                        label="Cancel"
                        onClick={() => this.handleCancel()}
                        style={commonStyles.buttonInlineRight}
                    />
                </div>
            </div>
        );
    }
}

DialogInventoryOrderAdjustToAvailable.propTypes = {
    jobId: PropTypes.string,
    locationId: PropTypes.string,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func
};

export default DialogInventoryOrderAdjustToAvailable;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogInventoryOrderAdjustToAvailable.js